import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import {
  listRequest,
  listSuccess,
  listFailure,
  createRequest,
  createSuccess,
  createFailure,
  deleteRequest,
  deleteSuccess,
  deleteFailure,
} from './genericReducers'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  tagsListRequest: ['params', 'listDataOffset'],
  tagsListSuccess: ['list'],
  tagsListFailure: ['listError'],

  tagsCreateRequest: ['params', 'callback'],
  tagsCreateSuccess: ['createData'],
  tagsCreateFailure: ['createError'],

  tagsDeleteRequest: ['id', 'callback'],
  tagsDeleteSuccess: [],
  tagsDeleteFailure: [],

  tagsKeyReset: ['key'],
})

export const TagTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  list: [],
  listFetching: null,
  listError: null,
  listDataOffset: 0,

  createData: {},
  createError: null,
  createFetching: false,

  deleteFetching: null,
  deleteError: null,
})

/* ------------- Reducers ------------- */

export const reset = (state) => state.merge(INITIAL_STATE)

export const resetBasedOnKey = (state, { key }) => {
  return state.merge({
    [key]: INITIAL_STATE[key],
  })
}

/* ------------- Selectors ------------- */

export const TagSelectors = {
  listDataOffset: (state) => state.tag.listDataOffset,
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.TAGS_LIST_REQUEST]: listRequest,
  [Types.TAGS_LIST_SUCCESS]: listSuccess,
  [Types.TAGS_LIST_FAILURE]: listFailure,

  [Types.TAGS_CREATE_REQUEST]: createRequest,
  [Types.TAGS_CREATE_SUCCESS]: createSuccess,
  [Types.TAGS_CREATE_FAILURE]: createFailure,

  [Types.TAGS_DELETE_REQUEST]: deleteRequest,
  [Types.TAGS_DELETE_SUCCESS]: deleteSuccess,
  [Types.TAGS_DELETE_FAILURE]: deleteFailure,

  [Types.TAGS_KEY_RESET]: resetBasedOnKey,
})
